'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../../../../node_modules/@fortawesome/pro-regular-svg-icons/index.cjs');
var index_es = require('../../../../../../node_modules/@fortawesome/react-fontawesome/index.es.cjs');
var React = require('react');
var Button_web = require('../../atoms/Button/Button.web.cjs');
var Icon_web = require('../../atoms/Icon/Icon.web.cjs');
var Typography_web = require('../../atoms/Typography/Typography.web.cjs');
var InternalSnackbar_web_styles = require('./InternalSnackbar.web.styles.cjs');
var proxy = require('../../../../../../node_modules/motion/node_modules/framer-motion/dist/es/render/components/motion/proxy.cjs');

/**
 * Individual snackbar item component that renders a single notification
 * with appropriate icon, message text, and optional action button
 *
 * @scope Internal
 */ const InternalSnackbarItem = ({ message, onRemoveMessage })=>{
    const theme = react.useTheme();
    const icon = React.useMemo(()=>{
        if (message.isPending) {
            return index.faSpinnerThird;
        }
        switch(message.variant){
            case "success":
                return index.faCheckCircle;
            case "critical":
                return index.faExclamationCircle;
            case "info":
            default:
                return index.faInfoCircle;
        }
    }, [
        message.variant,
        message.isPending
    ]);
    const handleAction = ()=>{
        message.onAction?.();
        onRemoveMessage(message.id);
    };
    // Only show action button if actionText is provided and not pending
    const shouldShowActionButton = Boolean(message.actionText && !message.isPending);
    return /*#__PURE__*/ jsxRuntime.jsxs(proxy.motion.div, {
        css: InternalSnackbar_web_styles.snackbar(theme, message.variant),
        role: "alert",
        "aria-live": "polite",
        "data-testid": `aviary-snackbar-${message.variant}`,
        initial: {
            opacity: 0,
            y: -10
        },
        animate: {
            opacity: 1,
            y: 0
        },
        exit: {
            opacity: 0,
            scale: 0.95
        },
        transition: {
            duration: 0.2,
            ease: [
                0.4,
                0.0,
                0.2,
                1
            ]
        },
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("div", {
                css: InternalSnackbar_web_styles.iconContainer,
                children: message.isPending ? /*#__PURE__*/ jsxRuntime.jsx(index_es.FontAwesomeIcon, {
                    icon: icon,
                    spin: true,
                    css: InternalSnackbar_web_styles.icon(theme)
                }) : /*#__PURE__*/ jsxRuntime.jsx(Icon_web.Icon, {
                    icon: icon,
                    intention: "inverse",
                    size: "medium",
                    customCss: InternalSnackbar_web_styles.icon(theme)
                })
            }),
            /*#__PURE__*/ jsxRuntime.jsx("div", {
                css: InternalSnackbar_web_styles.content,
                children: /*#__PURE__*/ jsxRuntime.jsx(Typography_web.Typography, {
                    variant: "callout",
                    intention: "inverse",
                    isMarginless: true,
                    customCss: InternalSnackbar_web_styles.message,
                    children: message.message
                })
            }),
            shouldShowActionButton && /*#__PURE__*/ jsxRuntime.jsx(Button_web.Button, {
                variant: "tertiary",
                size: "small",
                intention: "inverse",
                onClick: handleAction,
                children: message.actionText
            })
        ]
    });
};

exports.InternalSnackbarItem = InternalSnackbarItem;
//# sourceMappingURL=InternalSnackbarItem.web.cjs.map
